import React, { useState } from "react";
import { Clock } from "lucide-react";

// Desde cuándo ve el alumno una semana nueva.
//
// Las horas van en hora argentina, no en la del teléfono: si el coach
// arma la semana de viaje, "lunes 6:00" tiene que seguir siendo las 6
// de Buenos Aires. Argentina no cambia de horario, así que es -03:00
// todo el año.
const AR = -3 * 3600e3;
const dosCifras = (n) => String(n).padStart(2, "0");

// La fecha y hora de "ahora" en Buenos Aires, como campos sueltos.
function ahoraAR() {
  const d = new Date(Date.now() + AR);
  return { y: d.getUTCFullYear(), m: d.getUTCMonth(), d: d.getUTCDate(), dow: d.getUTCDay() };
}

const aISO = (y, m, d, hh = 6, mm = 0) => {
  const f = new Date(Date.UTC(y, m, d));
  return `${f.getUTCFullYear()}-${dosCifras(f.getUTCMonth() + 1)}-${dosCifras(f.getUTCDate())}` +
         `T${dosCifras(hh)}:${dosCifras(mm)}:00-03:00`;
};

// El próximo lunes a las 6. Si hoy es lunes, el de la semana que viene.
export function proximoLunes() {
  const h = ahoraAR();
  const faltan = ((8 - h.dow) % 7) || 7;
  return aISO(h.y, h.m, h.d + faltan);
}

// Lo que se propone al crear: el fin de semana se arma la semana que
// viene, así que de viernes a domingo se programa para el lunes. El
// resto de la semana, suele ser un alumno nuevo que la necesita ya.
export function visibilidadPorDefecto() {
  const { dow } = ahoraAR();
  return dow === 5 || dow === 6 || dow === 0 ? proximoLunes() : null;
}

export const estaOculta = (iso) => !!iso && new Date(iso).getTime() > Date.now();

const DIAS = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
export function textoVisible(iso) {
  if (!iso) return "Ahora";
  const d = new Date(new Date(iso).getTime() + AR);
  return `${DIAS[d.getUTCDay()]} ${d.getUTCDate()}/${d.getUTCMonth() + 1} · ` +
         `${d.getUTCHours()}:${dosCifras(d.getUTCMinutes())}`;
}

// Para el campo de fecha y hora del teléfono, que trabaja sin zona.
const aCampo = (iso) => {
  if (!iso) return "";
  const d = new Date(new Date(iso).getTime() + AR);
  return `${d.getUTCFullYear()}-${dosCifras(d.getUTCMonth() + 1)}-${dosCifras(d.getUTCDate())}` +
         `T${dosCifras(d.getUTCHours())}:${dosCifras(d.getUTCMinutes())}`;
};
const deCampo = (v) => (v ? `${v}:00-03:00` : null);

// Los tres botones: ahora, el lunes, o un día y hora a elección.
export function SelectorVisible({ value, onChange }) {
  const lunes = proximoLunes();
  const [eligiendo, setEligiendo] = useState(false);
  const modo = eligiendo ? "otra" : !value ? "ahora" : value === lunes ? "lunes" : "otra";
  const boton = (activo) => `flex-1 py-2 rounded-lg text-xs font-medium border transition-colors ${
    activo ? "bg-sky-400 text-black border-sky-400" : "text-neutral-400 border-neutral-600"}`;
  return (
    <div className="space-y-2">
      <span className="text-[10px] uppercase tracking-wider block text-neutral-500">
        La ven desde
      </span>
      <div className="flex gap-1.5">
        <button type="button" onClick={() => { setEligiendo(false); onChange(null); }} className={boton(modo === "ahora")}>
          Ahora
        </button>
        <button type="button" onClick={() => { setEligiendo(false); onChange(lunes); }} className={boton(modo === "lunes")}>
          {textoVisible(lunes).split(" · ")[0]} 6:00
        </button>
        <button type="button"
          onClick={() => { setEligiendo(true); if (!value) onChange(lunes); }}
          className={boton(modo === "otra")}>
          Elegir
        </button>
      </div>
      {modo === "otra" && (
        <input type="datetime-local" value={aCampo(value)}
          onChange={(e) => onChange(deCampo(e.target.value))}
          className="w-full bg-neutral-700 border border-neutral-600 focus:border-sky-400 focus:outline-none rounded-lg px-3 py-2 text-base" />
      )}
      <p className="text-[11px] text-neutral-500 flex items-center gap-1.5">
        <Clock size={12} />
        {value && estaOculta(value)
          ? `Oculta para el alumno hasta ${textoVisible(value)}`
          : "La ve apenas la crees"}
      </p>
    </div>
  );
}
